import FlagIcon from './FlagIcon'

type SettlementStatus = 'none' | 'settled' | 'settled-with-memo'

interface CurrencyCardProps {
  code: string
  flagCode: string
  isSelected: boolean
  onClick: () => void
  settlementStatus?: SettlementStatus
  inCart?: boolean
  // 교환 모드 등에서 카드 모서리에 표시할 라벨 (예: "A 매입")
  cornerLabel?: string
  cornerClass?: string
}

function CurrencyCard({ code, flagCode, isSelected, onClick, settlementStatus = 'none', inCart = false, cornerLabel, cornerClass = 'bg-fx-buy' }: CurrencyCardProps) {
  const getBorderClass = () => {
    if (isSelected) {
      return 'border-fx-buy bg-fx-buy-light'
    }

    if (inCart) {
      return 'border-emerald-400 bg-emerald-50 hover:border-emerald-500'
    }

    // Settlement status colors (only when not selected)
    switch (settlementStatus) {
      case 'settled':
        return 'border-green-500 bg-green-50 hover:border-green-600'
      case 'settled-with-memo':
        return 'border-yellow-500 bg-yellow-50 hover:border-yellow-600'
      default:
        return 'border-fx-card-inactive bg-white hover:border-gray-300'
    }
  }

  return (
    <button
      onClick={onClick}
      className={`relative p-2.5 rounded-lg border-[1.5px] transition-all ${getBorderClass()}`}
    >
      {inCart && (
        <span className="absolute top-1.5 right-2 text-xs font-bold text-emerald-600">✓</span>
      )}
      {cornerLabel && (
        <span className={`absolute top-1.5 left-1.5 text-[11px] font-bold px-1.5 py-0.5 rounded text-white ${cornerClass}`}>
          {cornerLabel}
        </span>
      )}
      <div className="flex flex-col items-center gap-2">
        <FlagIcon countryCode={flagCode} size="lg" />
        <span className="text-base font-medium text-gray-700">{code}</span>
      </div>
    </button>
  )
}

export default CurrencyCard
